import track from './track';

/**
 *
 * @param page
 * @param {IBreadcrumb[]} breadcrumbs
 * @param {IUser} user
 * @return {*|*}
 */
export default function pageView(page, breadcrumbs, user) {
    return track({
        event: 'pageLoad', // konstant, wird als Trigger in GTM genutzt
        mandant: 'amigos', // jeweiliger Mandant auf dem der Kunde ist (fix)
        pgc: ['amigos', ...breadcrumbs.map(b => b.name)],
        lang: globals.config.language,
        pnam: document.location.pathname, // URL Pfad abbilden
        paid: page.name, //eindeutige SeitenID
        zstr01: document.referrer ? document.referrer.split('/')[2] : '', // zielseite Tracking = HerkunftInfo --> Referral-URL–> URL mit der ich ursprünglich zum Shop gekommen bin ( document.referrer.split('/')[2]; )
        hrco: '200', //alternativ: 200,301,302,500 Responsecodes (welche verfügbar sind)
        eid: globals.config.env, //alternativ: qual - Enviroment der Applikation
        vlst: Boolean(user.isAuthenticated), // true/false ob der Kunde eingeloggt ist.,
        pageType: page.tracking_page_type,
        geschlecht: user.gender,
        yearOfBirth: user.year_of_birth,
        incu: user.incu == null ? null : Boolean(user.incu),
        // video: false, // TODO: true / false --> wenn Videokomponente auf der Seite, wird true mitgeschickt
        // age: user.age, // TODO: 33 (muss berechnet werden)
        // inre: user.inre, // TODO: true | false (der Kunde hat sich neu registriert, aber noch keine Bestellung aufgegeben -> Wert: true) --- (Kunde hat die erste Best. aufgegeben -> Wert: false)
    });
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/tracking/page-view.js